








































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import _ from "lodash";
import shrinkableMenu from "../components/shrinkable-menu/shrinkable-menu.vue";
import tagsPageOpened from "../components/tags-page-opened.vue";
import breadcrumbNav from "../components/breadcrumb-nav.vue";
import fullScreen from "../components/fullscreen.vue";
import lockScreen from "../components/lockscreen/lockscreen.vue";
import notice from "../components/notices/notice.vue";
import util from "../lib/util";
import copyfooter from "../components/Footer.vue";
import LanguageList from "../components/language-list.vue";
import AbpBase from "../lib/abpbase";
import SignalRAspNetCoreHelper from "../lib/SignalRAspNetCoreHelper";
import Util from "../lib/util";
import AppConsts from "@/lib/appconst";

@Component({
  components: {
    shrinkableMenu,
    tagsPageOpened,
    breadcrumbNav,
    fullScreen,
    lockScreen,
    notice,
    copyfooter,
    LanguageList,
  },
})
export default class Main extends AbpBase {
  shrink: boolean = false;
  locationUser: string = "";

  get userName() {
    const userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return userName;
  }
  get userAvatarUrl() {
    var avatarUrl = this.$store.state.session.user
      ? this.$store.state.session.user.avatarUrl
      : "";

    return _.isNil(avatarUrl) || _.isEmpty(avatarUrl)
      ? "../images/usericon.jpg"
      : Util.getAppUrlImage(avatarUrl);
  }
  isFullScreen: boolean = false;
  get openedSubmenuArr() {
    return this.$store.state.app.openedSubmenuArr;
  }
  get menuList() {
    return this.$store.state.app.menuList;
  }
  get pageTagsList() {
    return this.$store.state.app.pageOpenedList as Array<any>;
  }
  get currentPath() {
    return this.$store.state.app.currentPath;
  }
  get lang() {
    return this.$store.state.app.lang;
  }
  get avatorPath() {
    return localStorage.avatorImgPath;
  }
  get cachePage() {
    return this.$store.state.app.cachePage;
  }
  get menuTheme() {
    return this.$store.state.app.menuTheme;
  }
  get mesCount() {
    return this.$store.state.app.messageCount;
  }
  get tenantCode() {
    var name = this.$store.state.session.tenant
      ? this.$store.state.session.tenant.tenancyName
      : null;
    return name;
  }

  get clientCode() {
    var name = this.$store.state.session.client
      ? this.$store.state.session.client.code
      : null;
    return name;
  }

  async init() {
    const response = await this.$store.dispatch({
      type: "session/init",
    });
    if (
      !_.isEmpty(Util.abp.auth.getToken()) &&
      _.get(response, "user") == null
      // !_.startsWith(this.$route.path, '/error-403')
    ) {
      this.$router.push({
        path: "/",
        replace: true,
      });
    }

    if (
      !!this.$store.state.session.user &&
      this.$store.state.session.application.features["SignalR"]
    ) {
      if (
        this.$store.state.session.application.features["SignalR.AspNetCore"]
      ) {
        SignalRAspNetCoreHelper.initSignalR();
      }
    }
    SignalRAspNetCoreHelper.initSignalR();

    this.$store.commit("app/initCachepage");
    this.$store.commit("app/updateMenulist");
    if (
      this.$store.state.session.user &&
      this.$store.state.session.user.requireChangePassword
    ) {
      this.$router.replace("/change-password");
      return;
    }

    if (!_.isEmpty(this.$store.state.session.client)) {
      this.locationUser = this.$store.state.session.client.name;
    } else if (!_.isEmpty(this.$store.state.session.tenant)) {
      this.locationUser = this.$store.state.session.tenant.name;
    } else if (!_.isEmpty(this.$store.state.session.user)) {
      this.locationUser = this.$store.state.session.user.name;
    }

    let pathArr = util.setCurrentPath(this, this.$route.name as string);
    this.$store.commit("app/updateMenulist");
    if (pathArr.length >= 2) {
      this.$store.commit("app/addOpenSubmenu", pathArr[1].name);
    }
    this.checkTag(this.$route.name);
    if (!_.isNil(this.$store.state.session.notifications)) {
      this.$store.commit({
        type: "app/processInfoToNotify",
        data: this.$store.state.session.notifications,
      });
    }
    if (!_.isNil(this.$store.state.session.notificationTotalCount)) {
      this.$store.commit({
        type: "app/setNoticeUnreadTotalCount",
        data: this.$store.state.session.notificationTotalCount,
      });
    }
  }

  toggleClick() {
    this.shrink = !this.shrink;
  }

  handleClickUserDropdown(name: string) {
    if (name === "ownSpace") {
      util.openNewPage(this, "ownspace_index", null, null);
      this.$router.push({
        name: "ownspace_index",
      });
    } else if (name === "loginout") {
      this.$store.commit("app/logout", this);
      util.abp.auth.clearToken();
      abp.multiTenancy.setTenantIdCookie(null);
      location.reload();
    } else if (name === "changePass") {
      this.$root.$router.push({ name: "main-change-password" });
    } else if (name === "intruction") {
      window.open(
        "https://docs.google.com/document/d/1rDwywB24bVNAbncuCTjgeFiYSa6YXIE4QOj8REF7FVk/edit?usp=sharing",
        "_blank"
      );
    } else if (name == "loginOtherUser") {
      this.$store.commit("app/logout", this);
      util.abp.auth.clearToken();
      abp.multiTenancy.setTenantIdCookie(null);
      window.location.href = `${AppConsts.isUrl}Account/Logout`;
    }
  }
  checkTag(name?: string) {
    let openpageHasTag = this.pageTagsList.some((item: any) => {
      if (item.name === name) {
        return true;
      } else {
        return false;
      }
    });
    if (!openpageHasTag) {
      util.openNewPage(
        this,
        name as string,
        this.$route.params || {},
        this.$route.query || {}
      );
    }
  }
  handleSubmenuChange(val: string) {}
  beforePush(name: string) {
    if (name === "accesstest_index") {
      return false;
    } else {
      return true;
    }
  }
  fullscreenChange(isFullScreen: boolean) {}
  @Watch("$route")
  routeChange(to: any) {
    this.$store.commit("app/setCurrentPageName", to.name);
    let pathArr = util.setCurrentPath(this, to.name);
    if (pathArr.length > 2) {
      this.$store.commit("app/addOpenSubmenu", pathArr[1].name);
    }
    this.checkTag(to.name);
    localStorage.currentPageName = to.name;
  }
  @Watch("lang")
  langChange() {
    util.setCurrentPath(this, this.$route.name as string);
  }
  async mounted() {
    await this.init();
  }
  updated() {}

  created() {
    this.$store.commit("app/setOpenedList");
    abp.event.on("abp.signalr.connected", () => {
      util.abp.signalr.hubs.common.on("NotificationInfo", (notification) => {
        this.processInfoToNotify(notification);
        this.increaseNoticeUnreadTotalCount(1);
      });
    });
  }
  processInfoToNotify(notification) {
    this.$store.commit({
      type: "app/processInfoToNotify",
      data: notification,
    });
  }
  increaseNoticeUnreadTotalCount(increase) {
    this.$store.commit({
      type: "app/increaseNoticeUnreadTotalCount",
      data: increase,
    });
  }
}
